import React from 'react';
import { Container, Button, Form, Nav, Navbar, NavDropdown, Offcanvas } from 'react-bootstrap';
import "../componentCss/header.css";
import { Link } from 'react-router-dom';
import config from '../../config/config';
import Cookies from 'js-cookie'
let loginData = null;
try {
  const storageData = localStorage.getItem('loginSuccessNeurulaHealth');
  if (storageData) {
    loginData = JSON.parse(storageData);
    
    // Map string roles to numeric roles for compatibility
    if (loginData?.role && typeof loginData.role === 'string') {
      const roleMapping = {
        'super_admin': 1,
        'admin': 2,
        'super_user': 1,
        'administrator': 2
      };
      loginData.numericRole = roleMapping[loginData.role.toLowerCase()] || loginData.role;
    } else {
      loginData.numericRole = loginData?.role;
    }
  }
} catch (error) {
  loginData = null;
}

const Header = () => {
    return (
        <>
            <header>
                {['xl'].map((expand) => (
                    <Navbar key={expand} expand={expand} className="">
                        <Container >
                            <Navbar.Brand href="#">
                                <img src="assets/images/logo.png" alt="logo" className='mainLogo' />
                            </Navbar.Brand>
                            
                            {/* Login/Dashboard Button - Always visible */}
                            <Form className="d-flex head-btn ms-auto order-1 order-xl-2">
                                {loginData?.id ?
                                    <Link to={`${config.baseUrl}${loginData.numericRole == 2 || loginData.numericRole == 1 ? 'dashboard' : 'patient-records'}`}>
                                        <Button variant="secondary-btn2" className='px-5'>Dashboard</Button>
                                    </Link>
                                    :
                                    <Link to={`${config.baseUrl}login`}>
                                        <Button variant="secondary-btn2" className='px-5'>Login</Button>
                                    </Link>
                                }
                            </Form>

                            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} className="order-2 order-xl-1" />
                            <Navbar.Offcanvas
                                id={`offcanvasNavbar-expand-${expand}`}
                                aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                                placement="end"
                            >
                                <Offcanvas.Header closeButton>
                                    <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                                        Navigation
                                    </Offcanvas.Title>
                                </Offcanvas.Header>
                                <Offcanvas.Body>
                                    <Nav className="justify-content-center flex-grow-1 pe-3">
                                        <Nav.Link href="#">Resources</Nav.Link>
                                        <Nav.Link href="#">Services</Nav.Link>
                                        <Nav.Link href="#">Specialties</Nav.Link>
                                        <Nav.Link href="#">Solutions</Nav.Link>
                                        <Nav.Link href="#">Contact</Nav.Link>
                                    </Nav>
                                </Offcanvas.Body>
                            </Navbar.Offcanvas>
                        </Container>
                    </Navbar>
                ))}
            </header>

            {/*-------------------- Header Section Exit ------------------ */}

        </>
    )
}

export default Header;
